import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { loginRequest, isDevAuthBypass } from '@/auth/index';

/**
 * Sign-in wall - ClariCommand editorial styling (paper surface, mono eyebrow, serif title).
 * Redirects to / once an MSAL session exists (or under the dev bypass).
 */
export function Login() {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const idle = params.get('reason') === 'idle';

  useEffect(() => {
    if (isAuthenticated || isDevAuthBypass()) navigate('/', { replace: true });
  }, [isAuthenticated, navigate]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--paper)',
        padding: 24,
      }}
    >
      <div className="card" style={{ width: '100%', maxWidth: 400, textAlign: 'center' }}>
        <div className="section-eyebrow" style={{ justifyContent: 'center' }}>ClariDynamics</div>
        <h1 className="section-title" style={{ marginBottom: 6 }}>
          CDX <em>Pickups</em>
        </h1>
        <div className="section-rule" />
        {idle ? (
          <p className="section-lede" style={{ marginBottom: 24 }}>
            You were signed out after inactivity to protect member information. Sign in again to
            continue.
          </p>
        ) : (
          <p className="section-lede" style={{ marginBottom: 24 }}>
            Sign in with your ClariDynamics account.
          </p>
        )}
        <button
          type="button"
          className="btn btn-primary"
          style={{ width: '100%', justifyContent: 'center', padding: '10px 16px' }}
          onClick={() => void instance.loginRedirect(loginRequest)}
        >
          Sign in
        </button>
      </div>
    </div>
  );
}
